// UsersAdmin.jsx
import React, { useEffect, useState } from "react";
import {
  Tabs,
  Table,
  Input,
  Select,
  Button,
  Avatar,
  Tag,
  Card,
  Drawer,
  Form,
  message,
  Spin,
  Modal,
  Popconfirm
} from "antd";
import {
  UserOutlined,
  TeamOutlined,
  PlusOutlined,
  DeleteOutlined,
  DeleteColumnOutlined,
  DeleteFilled,
  DeleteRowOutlined,
  DeleteTwoTone
} from "@ant-design/icons";
import axios from "axios";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const { TabPane } = Tabs;



function UsersAdmin() {


   const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);

  const [loading, setLoading] = useState(false);
  const [activeRole, setActiveRole] = useState("ADMIN");

  const [admins, setAdmins] = useState([]);
  const [operations, setOperations] = useState([]);
  const [students, setStudents] = useState([]);
  const [instructors, setInstructors] = useState([]);

  const [search, setSearch] = useState("");

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [deleteStep, setDeleteStep] = useState(1);
const [deleteText, setDeleteText] = useState("");
const [selectedUser, setSelectedUser] = useState(null);


  const [form] = Form.useForm();

  const [addModalOpen, setAddModalOpen] = useState(false);

  /* ==================================================
     FETCH USERS
  ================================================== */

  const fetchUsers = async () => {
    try {
      setLoading(true);

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const [
        adminsRes,
        operationsRes,
        studentsRes,
        instructorsRes,
      ] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_API_URL}/user/admin/all-admins`,
          { headers }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/user/admin/all-operations`,
          { headers }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/user/admin/all-students`,
          { headers }
        ),
        axios.get(
          `${process.env.REACT_APP_API_URL}/user/admin/all-instructors`,
          { headers }
        ),
      ]);

      if (adminsRes.data.success) setAdmins(adminsRes.data.data);
      if (operationsRes.data.success)
        setOperations(operationsRes.data.data);
      if (studentsRes.data.success)
        setStudents(studentsRes.data.data);
      if (instructorsRes.data.success)
        setInstructors(instructorsRes.data.data);
    } catch (error) {
      toast.error("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  const confirmDeleteUser = async () => {
  if (deleteText !== "DELETE") return;

  await handleDeleteUser(selectedUser);

  setDeleteModalOpen(false);
  setDeleteStep(1);
  setDeleteText("");
  setSelectedUser(null);
};
  /* ==================================================
     FILTER LOGIC
  ================================================== */

  const getFilteredData = (data) => {
    return data.filter((user) =>
      user.FullName?.toLowerCase().includes(search.toLowerCase()) ||
      user.Email?.toLowerCase().includes(search.toLowerCase())
    );
  };

  /* ==================================================
     EDIT HANDLER
  ================================================== */

 
 

  /* ==================================================
     COMMON TABLE COLUMNS
  ================================================== */

 
  /* ==================================================
     ROLE STATS
  ================================================== */

  const roleStats = {
    ADMIN: admins.length,
    OPERATIONS: operations.length,
    STUDENT: students.length,
    INSTRUCTOR: instructors.length,
  };

  const roleDataMap = {
    ADMIN: admins,
    OPERATIONS: operations,
    STUDENT: students,
    INSTRUCTOR: instructors,
  };

  const handleCreateUser = async () => {
  try {
    const values = await form.validateFields();

    const headers = {
      Authorization: `Bearer ${token}`,
    };

    let url = "";
    let body = {
      FullName: values.FullName,
      Email: values.Email,
      Password: "hj4_hfkj4hfu",
      PhoneNumber: values.PhoneNumber,
      Country: values.Country,
      Role: activeRole,
    };

    if (activeRole === "ADMIN") {
      url = `${process.env.REACT_APP_API_URL}/user/user-admin`;
    }

    if (activeRole === "OPERATIONS") {
      url = `${process.env.REACT_APP_API_URL}/user/user-operations`;
    }

    if (activeRole === "STUDENT") {
      url = `${process.env.REACT_APP_API_URL}/user/user-student`;
      body.LeadType = values.LeadType;
    }

    if (activeRole === "INSTRUCTOR") {
      url = `${process.env.REACT_APP_API_URL}/user/user-instructor`;
    }

    // console.log(url)

    const response = await axios.post(url, body, { headers });

    if (response.data.success) {
      toast.success(`${activeRole} created successfully`);
      setAddModalOpen(false);
      fetchUsers(); // refresh
    }

  } catch (error) {
    toast.error("Failed to create user");
  }
};


const [sendingIds, setSendingIds] = useState([]);

const handleSendCredentials = async (record) => {
  try {
    setSendingIds((prev) => [...prev, record.id]);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/send-credentials`,
      {
        Email: record.Email,
        PhoneNumber: record.PhoneNumber,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // ✅ Only if backend confirms success
    if (response?.data?.success) {
      toast.success("Credentials sent successfully 🚀");
      fetchUsers(); // refresh table
    } else {
      toast.error(response?.data?.message || "Failed to send credentials ❌");
    }

  } catch (err) {
    toast.error(
      err?.response?.data?.message || "Server error ❌"
    );
  } finally {
    setSendingIds((prev) =>
      prev.filter((id) => id !== record.id)
    );
  }
};


const handleDeleteUser = async (record) => {
  try {
    const response = await axios.post(
  `${process.env.REACT_APP_API_URL}/user/delete-user`,
  {
      Email: record.Email,
      Role: record.Role,
    },
  {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    
  }
);

    if (response?.data?.success) {
      toast.success("User deleted successfully 🗑️");
      fetchUsers();
    } else {
      toast.error(response?.data?.message || "Delete failed");
    }

  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Server error while deleting ❌"
    );
  }
};


 return (
  <div className="min-h-screen p-8 bg-gray-50">

    <ToastContainer
  position="bottom-left"
  autoClose={5000}
  hideProgressBar={true}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="dark"
  className="!mb-6 !ml-4"
  toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
/>

    {/* ================= HEADER HERO ================= */}
    <div className="p-8 mb-8 text-white shadow-lg bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="mb-2 text-3xl font-bold">
            User Management
          </h1>
          <p className="opacity-90">
            Manage Admins, Operations, Students & Instructors
          </p>
        </div>

        <Button
  type="primary"
  size="large"
  icon={<PlusOutlined />}
  onClick={() => {
    form.resetFields();
    form.setFieldsValue({ Role: activeRole });
    setAddModalOpen(true);
  }}
  className="!bg-white !text-indigo-600 !font-semibold shadow-md hover:shadow-lg transition"
>
  ADD {activeRole}
</Button>
      </div>
    </div>

    {/* ================= ROLE SELECTOR ================= */}
    <div className="p-6 mb-6 bg-white shadow-sm rounded-2xl">

      <div className="flex flex-wrap items-center justify-between gap-4">

        {/* Role Tabs */}
        <div className="flex flex-wrap gap-3">
          {Object.keys(roleStats).map((role) => (
            <Button
              key={role}
              type={activeRole === role ? "primary" : "default"}
              shape="round"
              size="middle"
              onClick={() => setActiveRole(role)}
              className={`font-medium ${
                activeRole === role
                  ? "!bg-indigo-600 !border-none"
                  : ""
              }`}
            >
              {role} ({roleStats[role]})
            </Button>
          ))}
        </div>

        {/* Search */}
        <Input
          placeholder="Search by name or email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          allowClear
          className="w-72"
        />

      </div>
    </div>

    {/* ================= TABLE SECTION ================= */}
    <div className="p-6 bg-white shadow-sm rounded-2xl">

      <Spin spinning={loading}>

        <Table
          columns={[
            {
              title: "User",
              dataIndex: "FullName",
              render: (_, record) => (
                <div className="flex items-center gap-4">
                  <Avatar
                    size={45}
                    src={record.ProfilePhotoUrl}
                    icon={<UserOutlined />}
                  />

                  <div>
                    <div
                      className="font-semibold text-indigo-600 cursor-pointer hover:underline"
                      onClick={() => {
  navigate(`/academy/admin/users/${activeRole.toLowerCase()}/${record.id}`);
}}
                    >
                      {record.FullName}
                    </div>
                    <div className="text-xs text-gray-500">
                      {record.Email}
                    </div>
                  </div>
                </div>
              ),
            },
            {
              title: "Phone",
              dataIndex: "PhoneNumber",
            },
            {
              title: "Country",
              dataIndex: "Country",
            },
          {
  title: "Actions",
  render: (_, record) => {
    const isSending = sendingIds.includes(record.id);
    const isSent = record.CredentialStatus === "SENT";

    return (
      <div className="flex items-center gap-3">

        {/* Status Badge */}
        <span
          className={`px-3 py-1 text-xs font-semibold rounded-md ${
            isSent
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700 border border-yellow-400"
          }`}
        >
          {record.CredentialStatus || "PENDING"}
        </span>

        {/* Send Credentials */}
        <Button
          size="small"
          loading={isSending}
          onClick={() => handleSendCredentials(record)}
          className={
            isSent
              ? "!bg-green-600 !text-white !border-none hover:!bg-green-700 px-4 py-4 font-semibold"
              : "!bg-red-500 !text-white !border-none hover:!bg-red-600 px-4 py-4 font-semibold"
          }
        >
          {isSent ? "Resend Credentials" : "Send Credentials"}
        </Button>

        {/* Delete Icon */}
        <Button
  size="medium"
  danger
  icon={<DeleteOutlined />}
  className="!flex !items-center !justify-center"
  onClick={() => {
    setSelectedUser(record);
    setDeleteStep(1);
    setDeleteText("");
    setDeleteModalOpen(true);
  }}
/>

      </div>
    );
  },
}
          ]}
          dataSource={getFilteredData(roleDataMap[activeRole])}
          rowKey="id"
          pagination={{
            pageSize: 6,
            showSizeChanger: false,
          }}
          className="rounded-lg"
        />

      </Spin>
    </div>

   

    <Modal
  open={addModalOpen}
  onCancel={() => setAddModalOpen(false)}
  footer={null}
  centered
  width={500}
  className="rounded-2xl"
>
  <div className="p-6">

    {/* Header */}
    <div className="mb-6 text-center">
      <div className="text-2xl font-bold text-indigo-600">
        Create {activeRole}
      </div>
      <div className="text-sm text-gray-500">
        Fill details to add new {activeRole.toLowerCase()}
      </div>
    </div>

    <Form form={form} layout="vertical">

      <Form.Item
        name="FullName"
        label="Full Name"
        rules={[{ required: true }]}
      >
        <Input size="large" className="rounded-lg" />
      </Form.Item>

      <Form.Item
        name="Email"
        label="Email"
        rules={[{ required: true }]}
      >
        <Input size="large" className="rounded-lg" />
      </Form.Item>

      

     <Form.Item
  name="PhoneNumber"
  label="Phone Number"
  rules={[{ required: true, message: "Phone number is required" }]}
>
  <PhoneInput
    country={'in'}
    enableSearch
    inputStyle={{
      width: '100%',
      height: '48px',
      borderRadius: '10px',
      fontSize: '14px'
    }}
    buttonStyle={{
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px'
    }}
    containerStyle={{
      width: '100%'
    }}
    onChange={(value) => {
      form.setFieldsValue({
        PhoneNumber: `+${value}`
      });
    }}
  />
</Form.Item>

      <Form.Item
  name="Country"
  label="Country"
  rules={[{ required: true, message: "Please select your country" }]}
>
  <Select
    size="large"
    placeholder="Select country"
    className="rounded-lg"
    showSearch
    optionFilterProp="children"
  >
    <Select.Option value="INDIA">🇮🇳 India</Select.Option>
    <Select.Option value="USA">🇺🇸 United States</Select.Option>
    <Select.Option value="UK">🇬🇧 United Kingdom</Select.Option>
    <Select.Option value="CANADA">🇨🇦 Canada</Select.Option>
    <Select.Option value="AUSTRALIA">🇦🇺 Australia</Select.Option>
  </Select>
</Form.Item>

      {/* Role (Preselected & Disabled) */}
      <Form.Item
        name="Role"
        label="Role"
      >
        <Input
          size="large"
          disabled
          className="font-semibold bg-gray-100 rounded-lg"
        />
      </Form.Item>

      {/* LeadType only for Student */}
      {activeRole === "STUDENT" && (
        <Form.Item
  name="LeadType"
  label="Lead Type"
  rules={[{ required: true }]}
>
  <Select
    size="large"
    className="rounded-lg"
    placeholder="Select Lead Type"
  >
    <Select.Option value="STUDENT">
      Student
    </Select.Option>
    <Select.Option value="PROFESSIONAL">
      Professional
    </Select.Option>
  </Select>
</Form.Item>
      )}

      {/* Submit */}
      <Button
        type="primary"
        block
        size="large"
        onClick={handleCreateUser}
        className="mt-4 !bg-indigo-600 !border-none hover:!bg-indigo-700 rounded-lg font-semibold"
      >
        Create {activeRole}
      </Button>

    </Form>
  </div>
</Modal>

<Modal
  open={deleteModalOpen}
  onCancel={() => {
    setDeleteModalOpen(false);
    setDeleteStep(1);
    setDeleteText("");
    setSelectedUser(null);
  }}
  footer={null}
  centered
  title={
    <div className="text-lg font-semibold text-slate-800">
      Delete User Confirmation
    </div>
  }
>
  {selectedUser && (
    <div className="space-y-5">
      
      {/* USER DETAILS */}
      <div className="p-4 border border-red-100 bg-red-50 rounded-2xl">
        <p className="text-xs font-semibold tracking-wide text-red-500 uppercase">
          User Details
        </p>

        <div className="mt-3 space-y-2">
          <div>
            <p className="text-xs text-slate-500">Full Name</p>
            <h3 className="text-base font-semibold text-slate-800">
              {selectedUser.FullName}
            </h3>
          </div>

          <div>
            <p className="text-xs text-slate-500">Email</p>
            <h3 className="text-base font-semibold text-slate-800">
              {selectedUser.Email}
            </h3>
          </div>
        </div>
      </div>

      {/* WARNING TEXT */}
      <div className="p-4 border border-amber-200 bg-amber-50 rounded-2xl">
        <p className="text-sm font-medium leading-6 text-slate-700">
          Are you Confident that you DELETED All Course Access for{" "}
          <span className="font-bold text-red-600">
            {selectedUser.FullName}
          </span>
          ?
        </p>
      </div>

      {/* STEP 1 */}
      {deleteStep === 1 && (
        <div className="flex justify-end gap-3 pt-2">
          <Button
            onClick={() => {
              setDeleteModalOpen(false);
              setDeleteStep(1);
              setDeleteText("");
              setSelectedUser(null);
            }}
            className="rounded-lg"
          >
            No
          </Button>

          <Button
            danger
            onClick={() => setDeleteStep(2)}
            className="rounded-lg"
          >
            Yes
          </Button>
        </div>
      )}

      {/* STEP 2 */}
      {deleteStep === 2 && (
        <div className="space-y-4">
          <div>
            <label className="block mb-2 text-sm font-medium text-slate-700">
              Type <span className="font-bold text-red-600">DELETE</span> to confirm
            </label>

            <Input
              value={deleteText}
              onChange={(e) => setDeleteText(e.target.value)}
              placeholder="Enter DELETE"
              className="rounded-lg"
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button
              onClick={() => {
                setDeleteStep(1);
                setDeleteText("");
              }}
              className="rounded-lg"
            >
              Back
            </Button>

            <Button
              danger
              disabled={deleteText !== "DELETE"}
              onClick={confirmDeleteUser}
              className="rounded-lg"
            >
              Delete Permanently
            </Button>
          </div>
        </div>
      )}
    </div>
  )}
</Modal>

  </div>
);

}

export default UsersAdmin;
